import { Box, styled, Typography } from '@mui/material';
import { useState } from 'react';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { useTranslation } from 'react-i18next';

interface Props {
  limit: number;
  text: string;
}

const StyledBox = styled(Box)({
  gap: 1,
  width: '100%',
  overflowWrap: 'break-word',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
});

export function TruncatedText({ text, limit }: Props) {
  const { t } = useTranslation('common');
  const semantic = useAtlasSemanticThemeTokens();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleVisibility = () => {
    setIsExpanded(!isExpanded);
  };

  const isTextTruncated = text.length > limit;
  const truncatedText = text.slice(0, limit - 1);
  const remainingText = text.slice(limit);

  return (
    <StyledBox>
      {truncatedText}
      {isExpanded && remainingText}
      {isTextTruncated && (
        <>
          {!isExpanded && <Typography component='span'>...</Typography>}
          <Typography
            component='span'
            marginLeft={1}
            fontWeight={900}
            color={semantic.color.link.default.value}
            sx={{ cursor: 'pointer' }}
            onClick={toggleVisibility}
          >
            {t(`truncatedText.${isExpanded ? 'showLess' : 'showMore'}`)}
          </Typography>
        </>
      )}
    </StyledBox>
  );
}
